import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { utils } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import UploadImageMenu from 'src/js/modules/common/components/upload-image-menu';
import getMenuCssPosition from 'src/js/modules/context-menu/helpers/get-menu-css-position';

const { ActionButton } = designSystem;
const VERTICAL_GAP = 6;

function ReplaceImageButton({
  label,
  elementId = null,
  onClick = utils.noop,
  onTriggerUploadImageClick = utils.noop,
  onTriggerBrowseStockPhotosClick = utils.noop,
  onPhotoStockDialogCancel = utils.noop,
  ...otherProps
}) {
  const triggerNodeRef = useRef(null);

  const calculatePositionDecorator = useCallback((menuElement) => {
    const { x, y } = triggerNodeRef.current.getBoundingClientRect();
    const { height } = menuElement.getBoundingClientRect();
    const eventY = y - height / 2 - VERTICAL_GAP;
    return getMenuCssPosition(menuElement, x, eventY);
  }, []);

  const getContextMenuPosition = useCallback(() => {
    if (!triggerNodeRef.current) return { x: 0, y: 0 };
    const { x, y } = triggerNodeRef.current.getBoundingClientRect();
    return {
      x,
      y,
    };
  }, []);

  return (
    <UploadImageMenu
      triggerNodeRef={triggerNodeRef}
      getContextMenuPosition={getContextMenuPosition}
      calculatePositionDecorator={calculatePositionDecorator}
      onClick={onClick}
      elementId={elementId}
      onTriggerUploadImageClick={onTriggerUploadImageClick}
      onTriggerBrowseStockPhotosClick={onTriggerBrowseStockPhotosClick}
      onPhotoStockDialogCancel={onPhotoStockDialogCancel}
      {...otherProps}
    >
      <ActionButton format="solid-white" size="small" label={label} />
    </UploadImageMenu>
  );
}

ReplaceImageButton.propTypes = {
  elementId: PropTypes.string,
  label: PropTypes.string.isRequired,
  onImageUpload: PropTypes.func.isRequired,
  onStockPhotoUpload: PropTypes.func.isRequired,
  onWrongFileType: PropTypes.func.isRequired,
  accept: PropTypes.string.isRequired,
  onTriggerUploadImageClick: PropTypes.func,
  onClick: PropTypes.func,
  onPhotoStockDialogCancel: PropTypes.func,
  onTriggerBrowseStockPhotosClick: PropTypes.func,
};

export default ReplaceImageButton;
